import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { Layout } from 'antd';
import AdminRoute from '../routes/AdminRoute';

import AppHeader from '../components/AppHeader';
import Employees from '../pages/employees/Employees';
import CreateEmployee from '../pages/employees/CreateEmployee';
import AllCustomers from '../pages/customer/AllCustomers';
import CustomerCreate from '../pages/customer/CustomerCreate';
import CustomerLayout from './CustomerLayout';
import CD from '../pages/customer/CustomerDashboard';
import LeadPage from '../pages/leads/LeadPage';
import LeadIndex from '../pages/leads/LeadsIndex';

const AppLayout = (props) => {
  const { path } = props.match;
  return (
    <Layout className="ec-container">
      <AppHeader />
      <Layout>
        <Switch>
          <Route exact path={path} component={CD} />
          <Route path={`${path}/leads`} component={LeadIndex} />
          <Route path={`${path}/lead/:cid`} component={LeadPage} />
          <Route exact path={`${path}/customers`} component={AllCustomers} />
          <Route exact path={`${path}/customers/create`} component={CustomerCreate} />
          <Route path={`${path}/customers/:id`} component={CustomerLayout} />
          <AdminRoute exact path={`${path}/admin/employees`} component={Employees} />
          <AdminRoute path={`${path}/admin/employees/create`} component={CreateEmployee} />
        </Switch>
      </Layout>
    </Layout>
  );
};

AppLayout.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default AppLayout;



// WEBPACK FOOTER //
// ./src/layouts/AppLayout.jsx